<template>
  <div class="history">
    <el-drawer
      size="500px"
      title="查看"
      :data="visible"
      :visible.sync="visible"
      :before-close="cancelModal"
    >
      <div class="title">修改前审批流程</div>
      <div
        class="info"
        style=" margin-left: 45px;"
        v-if="flowList && flowList.length > 0"
      >
        <div class="approvalFlow">
          <div class="steps">
            <div class="step" v-for="(item, i) in flowList" :key="i">
              <div class="left">
                <div class="round"></div>
                <div class="line" v-if="i < flowList.length - 1"></div>
              </div>
              <div class="right">
                <div class="label">{{ getCheckTitle(i + 1) }}</div>
                <div class="desc">
                  <!-- {{stringToArr(item.companyStaffName)}}{{item.companyStaffName}} -->
                  <div class="tags">
                    <div
                      class="tag"
                      v-for="(tag, idx) in stringToArr(
                        item.companyPositionName
                      )"
                      :key="idx"
                    >
                      {{ tag }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <el-timeline>
            <el-timeline-item
              :timestamp="item.companyPositionName"
              placement="top"
              class="myActive"
              color="#409eff"
              v-for="(item, index) in flowList"
              :key="index"
            >
              <div>{{ stringToArr(item.companyStaffName) }}</div>
            </el-timeline-item>
          </el-timeline> -->
        </div>
      </div>
      <el-empty v-else></el-empty>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getFlowNode } from "@/api/chain/ledgerDig2";
import { convertToChinaNum } from "@/util/util";
export default {
  props: {
    //弹窗状态
    visible: {
      type: Boolean,
      default: false,
    },
    flowList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters(["permissions"]),
  },
  methods: {
    getCheckTitle(val){
      return `第${convertToChinaNum(val)}审批人`
    },
    stringToArr(val) {
      return val ? val.split(",") : [];
    },
    cancelModal() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-drawer__header {
  margin-bottom: 10px;
}
/deep/ .el-timeline-item__timestamp {
  line-height: 20px;
}
// /deep/.el-timeline-item__node--normal {

//   border: 2px solid #35b1ff;
//   margin: 8px 0;
// }
.steps {
  .step {
    height: 100px;
    display: flex;
    .left {
      .round {
        width: 4px;
        height: 4px;
        border: 2px solid #35b1ff;
        border-radius: 50%;
        margin: 8px 0;
      }
      .line {
        margin-left: 3px;
        width: 2px;
        height: 72px;
        background: #35b1ff;
      }
    }
    .right {
      margin-left: 20px;
      .label {
        font-weight: 400;
        font-size: 16px;
        color: #313133;
        margin-bottom: 4px;
      }
      .desc {
        .tags {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          .tag {
            padding: 3px 13px;
            background: #ffffff;
            border-radius: 3px;
            border: 1px solid #ededf0;
            font-weight: 400;
            font-size: 12px;
            color: #313133;
            margin-right: 4px;
            margin-bottom: 4px;
          }
        }
      }
    }
  }
}
.title {
  font-weight: 500;
  font-size: 14px;
  color: #313133;
  padding: 32px 0;
  padding-left: 30px;
}
/deep/.el-drawer__header{
  border-bottom:  1px solid #EDEDF0;
  margin-bottom: 0;
  padding: 11px 18px;
}
</style>
